import React from 'react';
import { useNavigate } from 'react-router-dom';
import bg_image from "../../images/thank-you-modal-bg.jpg";
import bg_image_mobile from "../../images/thank-you-modal-bg-mobile.jpg";
import './SuccessModal.css';

function SuccessModal({ closeModal }) {
    const isMobile = window.innerWidth < 768;
    const navigate = useNavigate();
    return (
        <div className="modal modal-md fade show" style={{ background: "rgba(0, 0, 0, 0.80)", display: "flex" }} id="successModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog" role="document" style={{ maxWidth: (isMobile) ? "300px" : "650px" }}>
                <div className="modal-content" style={{ marginTop: "10%" }}>
                    <div className="modal-body">
                        <button type="button" onClick={closeModal} className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <div
                            className="container"
                            style={{
                                // backgroundImage: `url(${bg_image})`,
                                backgroundImage: `url(${isMobile ? bg_image_mobile : bg_image})`,
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "contain",
                                backgroundPosition: "center",
                                position: "relative",
                                width: "100%",
                                height: "100%",
                                minHeight: "600px",
                            }}
                        >
                            <div className='row'>
                                <div className='col-md-12' style={{ textAlign: "center", marginTop: (isMobile) ? '85%' : '30%' }}>
                                    <p className='normalText'>We’re growing faster than expected! </p>
                                    <p className='normalText'>Thanks to a recent surge of interest (and one amazing shoutout to <a href="https://www.instagram.com/satshyaa/?hl=en" target='_blank'>@satshyaa</a>), we’re currently at full capacity. We’re thrilled by your enthusiasm for smarter waste tracking and sustainable living.</p>
                                    <p className='normalText' style={{ fontWeight: 700 }}>We will reach out to you on email or phone number that you have provided, to share more updates on when we’re coming to your neighbourhood</p>
                                    <p className='normalText'>Thanks for your patience — change takes time, and you’re helping to drive it.</p>
                                    <a href="/home" className='btn backToHomeBtn' style={{ marginTop: (isMobile) ? "10px" : "30px", marginBottom: (isMobile) ? "40px" : "" }} onClick={(e) => { e.preventDefault(); navigate("/") }}>Back To Home Page</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SuccessModal;